<template>
  <el-dialog
    title="新增费用"
    :visible.sync="visible"
    width="600px"
    :before-close="handleClose"
  >
    <el-form ref="form" :model="form" :rules="rules" label-width="100px">
      <!-- 费用类别改为文本框 -->
      <el-form-item label="费用类别" prop="feeType">
        <el-input
          v-model="form.feeType"
          placeholder="请输入费用类别"
          class="w-full"
        ></el-input>
      </el-form-item>
      <el-form-item label="费用明细" prop="feeDetail">
        <el-input
          v-model="form.feeDetail"
          placeholder="请输入费用明细"
        ></el-input>
      </el-form-item>
      <el-form-item label="费用金额" prop="feeAmount">
        <el-input-number
          v-model="form.feeAmount"
          :min="0"
          precision="2"
          placeholder="请输入费用金额"
        ></el-input-number>
      </el-form-item>
      <el-form-item label="支付时间" prop="payTime">
        <el-date-picker
          v-model="form.payTime"
          type="datetime"
          placeholder="选择支付时间"
          value-format="yyyy-MM-dd HH:mm:ss"
          class="w-full"
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="备注" prop="remark">
        <el-input
          v-model="form.remark"
          type="textarea"
          :rows="3"
          placeholder="请输入备注"
        ></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="handleSubmit" :loading="loading"
        >确 定</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
import { addFundPayment } from "@/api/fee/fundPaymentApi";

export default {
  name: "AddFundpayment",
  data() {
    return {
      visible: false,
      loading: false,
      feeTypes: [], // 保留但不再使用，避免报错（也可直接删除）
      form: {
        feeType: "", // 改为文本输入值
        feeDetail: "",
        feeAmount: 0,
        payTime: "",
        remark: "",
      },
      rules: {
        // 调整费用类别校验规则（触发方式改为blur）
        feeType: [
          { required: true, message: "请输入费用类别", trigger: "blur" },
        ],
        feeDetail: [
          { required: true, message: "请输入费用明细", trigger: "blur" },
        ],
        feeAmount: [
          { required: true, message: "请输入费用金额", trigger: "blur" },
        ],
        payTime: [
          { required: true, message: "请选择支付时间", trigger: "change" },
        ],
      },
    };
  },
  mounted() {
    // 移除获取费用类别下拉列表的方法调用
  },
  methods: {
    // 删除getFeeTypeList方法（不再需要获取下拉选项）
    open() {
      this.visible = true;
      this.resetForm();
    },
    handleClose() {
      this.visible = false;
      this.resetForm();
    },
    resetForm() {
      this.form = {
        feeType: "",
        feeDetail: "",
        feeAmount: 0,
        payTime: "",
        remark: "",
      };
      this.$refs.form.resetFields();
    },
    async handleSubmit() {
      try {
        await this.$refs.form.validate();
        this.loading = true;
        const params = {
          ...this.form,
          communityId: this.$parent.getCommunityId(),
        };
        await addFundPayment(params);
        this.$message.success("新增成功");
        this.handleClose();
        this.$emit("handleRefreshFee");
      } catch (error) {
        if (error !== false) console.error("新增失败:", error);
        this.$message.error("新增失败");
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.w-full {
  width: 100%;
}
</style>
